/**
 * [ File :: G_Variable.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/graphic/G_Variable.js
 * @설명 : 변수 객체
 * @진행 : 진행중
 * @주의 :
 * @일자 : 2018.08.17
 * @작성 : Lee Mi Reu
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
import B_Real       from 'canvas/base/dev/child/base/B_Real';
import B_ChildWorld from 'canvas/base/dev/child/base/B_ChildWorld';
import B_GridChild  from 'canvas/base/dev/child/grid/B_GridChild';
import G_GridChild  from 'canvas/grid/dev/child/grid/G_GridChild';
import G_VariableText from 'canvas/grid/dev/child/text/G_VariableText';

let mix = (superclass) => new MixinBuilder(superclass);

const G_Variable = (function () {
  const PADDING = 5
  const STROKE_SIZE = 2
  const MARGIN = 10

  return class extends mix(B_Real).with(B_ChildWorld, B_GridChild, G_GridChild) {
    constructor(obj) {
      obj.x = 2
      obj.y = 3
      obj.pointX = 20
      obj.pointY = 0
      super(obj)

      const FONT_SIZE = 20

      this._variable = obj.variable

      // Variable, Text 배경, 테두리 객체 외부로 뺄 예정
      this._border = new createjs.Shape();
      this._container.addChild(this._border)

      this._background = new createjs.Shape()
      this._container.addChild(this._background)

      if (true) {
        this._labelObj = new G_VariableText({
          text: obj.variable,
          size: FONT_SIZE,
          color: obj.color,
          container: this._container,
          CODMOS: this.CODMOS
        })
        this._container.addChild(this._labelObj._object)
      }

      this._variableObj = new G_VariableText({
        suffix: obj.suffix,
        text: 'loading',
        variable: obj.variable,
        size: FONT_SIZE,
        color: obj.color,
        container: this._container,
        CODMOS: this.CODMOS,
        background: true,
        backgroundColor: '#05fff6'
      })

      this._container.addChild(this._variableObj._object)

      this._variableObj._object.x = this._labelObj ? this._labelObj._object.getBounds().width + 10 : 0

      // if (obj.isTest === true) this.setEditorEvent()

      this._object = this._container
    }

    _setArea(w, h) {
      if (super._checkArea(w, h)) {
        this._object.scaleX = this._w / this._object.getBounds().width;
        this._object.scaleY = this._h / this._object.getBounds().height;
      }
    }

    _setPoint(px, py) {
      if (super._checkReg(px, py)) {
        let preHeight = 0
        if (typeof this.CODMOS.WORLD.LIST.variable === 'object') {
          Object.values(this.CODMOS.WORLD.LIST.variable).forEach(e => {
            if (e._id !== this._id)
              preHeight += e._container.getBounds().height + STROKE_SIZE * 2 + PADDING + MARGIN
          })
        }
        this._object.regX = 35;
        this._object.regY = 30 - preHeight;
      }
    }

    _getOriginWidth() {
      return this._object.getBounds().width;
    }

    _getOriginHeight() {
      return this._object.getBounds().height;
    }

    get variable() {
      return this._variable
    }

    get value() {
      this._variableObj._text
    }

    set value(value) {
      this._variableObj.value = value;
      this.sizeUpdate()
    }

    /**
     * [ Function :: sizeUpdate ]
     *
     * @DES :: 내용이 바뀔 때마다 테두리와 hit 이벤트 구역을 재설정
     * @IP1 :: null
     * @O.P :: null
     */
    sizeUpdate() {
      const BOUNDS = this._container.getBounds()

      this._border.graphics.clear().beginStroke("rgba(68,72,80,0.2)")
        .setStrokeStyle(STROKE_SIZE, "round")
        .drawRoundRect(
          -(PADDING + STROKE_SIZE),
          -(PADDING + STROKE_SIZE),
          BOUNDS.width + ((PADDING + STROKE_SIZE) * 2),
          BOUNDS.height + ((PADDING + STROKE_SIZE) * 2),
          5
        );

      this._background.graphics.clear().beginFill("rgba(255,255,255,0.5)")
        .drawRoundRect(
          -(PADDING + STROKE_SIZE),
          -(PADDING + STROKE_SIZE),
          BOUNDS.width + ((PADDING + STROKE_SIZE) * 2),
          BOUNDS.height + ((PADDING + STROKE_SIZE) * 2),
          5
        )

      if (typeof this._hit !== 'undefined')
        this._hit.graphics.clear().beginFill("#000")
          .drawRoundRect(
            -(PADDING + STROKE_SIZE),
            -(PADDING + STROKE_SIZE),
            BOUNDS.width + ((PADDING + STROKE_SIZE) * 2),
            BOUNDS.height + ((PADDING + STROKE_SIZE) * 2),
            5
          )
    }

    /**
     * [ Function :: setEditorEvent ]
     *
     * @DES :: 에디터에서 실행 시 드래그 이벤트 설정
     * @IP1 :: null
     * @O.P :: null
     */
    setEditorEvent() {
      const object = this._container

      this._hit = new createjs.Shape()

      object.hitArea = this._hit

      object.cursor = 'pointer'
      object.addEventListener('mousedown', () => {
        game.isVariableMove = true
      })
      object.addEventListener('pressmove', e => {
        const BOUNDS = this._container.getBounds();
        this._pixelX = e.stageX - (BOUNDS.width / 2)
        this._pixelY = e.stageY - (BOUNDS.height / 2)
      })
      object.addEventListener('pressup', () => {
        game.isVariableMove = false
        const object = game.editorObject
        let objectArray = object.get()
        const index = objectArray.findIndex(e => {
          if (e.id === this.id) return e
        })
        const variable = objectArray.splice(index, 1)[0]
        const BOUNDS = this._container.getBounds();
        variable.x = (this._pixelX + (BOUNDS.width / 2)) / this.CODMOS.CANVAS.width * 100
        variable.y = (this._pixelY + (BOUNDS.height / 2)) / this.CODMOS.CANVAS.height * 100
        objectArray.splice(index, 0, variable)
        object.set(objectArray)
      })
    }
  }
}());

export default G_Variable;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/graphic/G_Variable.js